import { useContext, useEffect, useState } from "react";
import { Loader } from "@googlemaps/js-api-loader";
import AppGlobalsContext from "app/AppGlobalsContext";
import { useAnalytics } from "app/utils/analytics/useAnalytics";

export const GOOGLE_API_LOAD_STATUS = {
	LOADING: "loading",
	READY: "ready",
	ERROR: "error",
};

const useGoogleMapsApi = () => {
	const [googleApiLoadStatus, setGoogleApiLoadStatus] = useState(GOOGLE_API_LOAD_STATUS.LOADING);
	const { shop = "", envVars = {} } = useContext(AppGlobalsContext);
	const language = shop.slice(0, 2);
	const { GOOGLE_API_KEY } = envVars;
	const { track } = useAnalytics();

	useEffect(() => {
		const isGoogleAlreadyLoaded =
			window.google && window.google.maps && window.google.maps.places;

		// Ne rien faire si l'API est déjà chargée
		if (isGoogleAlreadyLoaded) {
			setGoogleApiLoadStatus(GOOGLE_API_LOAD_STATUS.READY);
			return;
		}

		// https://googlemaps.github.io/js-api-loader/index.html
		const loader = new Loader({
			apiKey: GOOGLE_API_KEY,
			version: "weekly",
			libraries: ["places"],
			language: language,
		});

		loader
			.importLibrary("places")
			.then(() => {
				setGoogleApiLoadStatus(GOOGLE_API_LOAD_STATUS.READY);
			})
			.catch(error => {
				setGoogleApiLoadStatus(GOOGLE_API_LOAD_STATUS.ERROR);
				track("google_api_load_error", { error: error.message });
			});
	}, [language, GOOGLE_API_KEY]);

	return googleApiLoadStatus;
};

export default useGoogleMapsApi;
